var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49994 17.4146V1.58544C1.49994 1.56085 1.50479 1.55316 1.50678 1.54999C1.50687 1.54986 1.50694 1.54974 1.50701 1.54962C1.5116 1.54224 1.52334 1.52837 1.5455 1.51621C1.56766 1.50406 1.58895 1.49988 1.60417 1.5C1.61454 1.50008 1.63103 1.50161 1.65907 1.51895L14.4591 9.4335C14.4835 9.44861 14.4896 9.45959 14.4918 9.46376C14.4959 9.47127 14.4999 9.4837 14.4999 9.5C14.4999 9.5163 14.4959 9.52873 14.4918 9.53624C14.4896 9.54041 14.4835 9.55139 14.4591 9.5665L1.65907 17.4811C1.63103 17.4984 1.61454 17.4999 1.60417 17.5C1.58895 17.5001 1.56765 17.4959 1.5455 17.4838C1.52333 17.4716 1.5116 17.4578 1.50701 17.4504L1.50678 17.45C1.50479 17.4468 1.49994 17.4391 1.49994 17.4146Z",
    stroke: "white",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e371383ebc38d1bdc157273bb7f435b5.svg";
export { ForwardRef as ReactComponent };